import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import CategoryPage from './pages/CategoryPage';
import ProductPage from './pages/ProductPage';
import LikedPage from './pages/LikedPage';
import SwipePage from './pages/SwipePage';
import BottomNav from './components/BottomNav';
import TopBar from './components/TopBar';
import { useEffect } from 'react';
import { fetchProducts } from './Func/Products';
import HandleUserLinkPage from './pages/HandleUserLinkPage'; // New component for handling /:username
import { Helmet } from 'react-helmet';
import EmailSubscriptionPopup from './components/EmailSubscriptionPopup';

function App() {

  useEffect(() => {
    fetchProducts(); // Fetch products for other routes
  }, []);

  return (
    <div className="App">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "HolyWearHouse",
            "description": "Christian clothing brands offering faith-inspired apparel.",
            "url": "https://holywearhouse.com",
            "logo": "https://holywearhouse.com/logo.png"
          })}
        </script>
      </Helmet>

      <TopBar />

      {/* Routes */}
      <Routes>
        <Route path="/" element={<Navigate to="/categories" />} />
        <Route path="/categories" element={<CategoryPage />} />
        <Route path="/products" element={<ProductPage />} />
        <Route path="/liked" element={<LikedPage />} />
        <Route path="/swipe" element={<SwipePage />} />
        <Route path="/:username" element={<HandleUserLinkPage />} /> {/* New route for /:username */}
      </Routes>

      <BottomNav />

      {/* Email Subscription Popup */}
      {/* <EmailSubscriptionPopup /> */}
      
    </div>
  );
}

export default App;
